import { Reducer } from "redux";
import { AiResearchAction } from "./actions";
import { Reference } from "models/AiResearch";
import { SseStatus } from "hooks/useRequest";

export interface AiResearchState {
  answer: string;
  talkId: string | null;
  progress: string | null;
  references: Reference[];
  sseStatus: SseStatus | null;
  ids?:
    | {
        questionId: string;
        answerId: string;
      }
    | undefined;
  isError: boolean;
}

const initialState: AiResearchState = {
  answer: "",
  talkId: null,
  progress: "接続しています...",
  references: [],
  sseStatus: null,
  ids: undefined,
  isError: false
};

export const aiResearch: Reducer<AiResearchState, AiResearchAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "search/aiResearch/SET_ANSWER":
      return {
        ...state,
        answer: action.payload
      };
    case "search/aiResearch/SET_TALK_ID":
      return {
        ...state,
        talkId: action.payload
      };
    case "search/aiResearch/ADD_REFERENCE":
      return {
        ...state,
        references: [...state.references, action.payload]
      };
    case "search/aiResearch/SET_PROGRESS":
      return { ...state, progress: action.payload };
    case "search/aiResearch/SET_SSE_STATUS":
      return {
        ...state,
        sseStatus: action.payload
      };
    case "search/aiResearch/SET_IDS":
      return {
        ...state,
        ids: {
          questionId: action.payload.questionId,
          answerId: action.payload.answerId
        }
      };
    case "search/aiResearch/SET_IS_ERROR":
      return {
        ...state,
        isError: action.payload
      };
    case "search/aiResearch/CLEAR_RESULT":
      return {
        ...state,
        answer: "",
        talkId: null,
        progress: "接続しています...",
        references: [],
        sseStatus: null,
        ids: undefined,
        isError: false
      };
    default:
      return state;
  }
};
